import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { url } from "../../utils/config";
import { delayMessage } from "../../utils/delayMessage";
import { serverMessage } from "../../utils/serverMessage";

interface singlePostJobState {
  isSinglePostJobLoading: boolean;
  pendingRequestTimer: any;
  singleJobFetched: any;
}

const initialState: singlePostJobState = {
  isSinglePostJobLoading: false,
  singleJobFetched: {},
  pendingRequestTimer: null,
};

export const getSinglePostJob = createAsyncThunk(
  "getSinglePost",
  async (details: string | undefined, thunkAPI) => {
    try {
      const { data } = await axios.get(`${url.baseUrl}/postJob/${details}`);
      // console.log(data.data.postJob);

      return data.data.postJob;
    } catch (error: any) {
      console.log(error.response);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const singlePostJobSlice = createSlice({
  name: "singlePostJob",
  initialState,
  reducers: {
    //
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSinglePostJob.pending, (state) => {
        state.isSinglePostJobLoading = true;
        // Start a timer to show toast message if request is still pending after 10 seconds
        if (state.pendingRequestTimer) {
          clearTimeout(state.pendingRequestTimer);
        }
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(getSinglePostJob.fulfilled, (state, { payload }) => {
        // console.log(payload);

        state.isSinglePostJobLoading = false;
        state.singleJobFetched = payload;

        // Clear timeout
        if (state.pendingRequestTimer) {
          clearTimeout(state.pendingRequestTimer);
          state.pendingRequestTimer = null; // Reset the timer ID
        }
      })
      .addCase(getSinglePostJob.rejected, (state, { payload }: any) => {
        state.isSinglePostJobLoading = false;
        serverMessage(payload);

        // Clear timeout
        if (state.pendingRequestTimer) {
          clearTimeout(state.pendingRequestTimer);
          state.pendingRequestTimer = null; // Reset the timer ID
        }
      });
  },
});

export default singlePostJobSlice.reducer;
